/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CancelContractRequestDto,
  CompleteContractRequestDto,
  ContractsControllerCancelContract204,
  ContractsControllerCompleteContract200,
  ContractsControllerConfirmCancellation200,
  ContractsControllerCreateContract201,
  ContractsControllerDownloadCancellationPdf200,
  ContractsControllerDownloadPdf200,
  ContractsControllerGetCardPaymentStatus200,
  ContractsControllerGetContract200,
  ContractsControllerGetMyContracts200,
  ContractsControllerGetMyContractsParams,
  ContractsControllerRejectCancellation200,
  ContractsControllerRejectCancellationBody,
  ContractsControllerRequestCancellation200,
  CreateContractRequestDto,
} from "../client.schemas";

import { api } from "../../lib/orval-mutator";
import type { ErrorType, BodyType } from "../../lib/orval-mutator";

/**
 * @summary 내 계약 목록 조회
 */
export const contractsControllerGetMyContracts = (
  params?: ContractsControllerGetMyContractsParams,
  signal?: AbortSignal,
) => {
  return api<ContractsControllerGetMyContracts200>({
    url: `/contracts/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getContractsControllerGetMyContractsQueryKey = (
  params?: ContractsControllerGetMyContractsParams,
) => {
  return [`/contracts/me`, ...(params ? [params] : [])] as const;
};

export const getContractsControllerGetMyContractsQueryOptions = <
  TData = Awaited<ReturnType<typeof contractsControllerGetMyContracts>>,
  TError = ErrorType<unknown>,
>(
  params?: ContractsControllerGetMyContractsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerGetMyContracts>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getContractsControllerGetMyContractsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof contractsControllerGetMyContracts>>
  > = ({ signal }) => contractsControllerGetMyContracts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof contractsControllerGetMyContracts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ContractsControllerGetMyContractsQueryResult = NonNullable<
  Awaited<ReturnType<typeof contractsControllerGetMyContracts>>
>;
export type ContractsControllerGetMyContractsQueryError = ErrorType<unknown>;

export function useContractsControllerGetMyContracts<
  TData = Awaited<ReturnType<typeof contractsControllerGetMyContracts>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ContractsControllerGetMyContractsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerGetMyContracts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerGetMyContracts>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerGetMyContracts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useContractsControllerGetMyContracts<
  TData = Awaited<ReturnType<typeof contractsControllerGetMyContracts>>,
  TError = ErrorType<unknown>,
>(
  params?: ContractsControllerGetMyContractsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerGetMyContracts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerGetMyContracts>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerGetMyContracts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useContractsControllerGetMyContracts<
  TData = Awaited<ReturnType<typeof contractsControllerGetMyContracts>>,
  TError = ErrorType<unknown>,
>(
  params?: ContractsControllerGetMyContractsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerGetMyContracts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 내 계약 목록 조회
 */

export function useContractsControllerGetMyContracts<
  TData = Awaited<ReturnType<typeof contractsControllerGetMyContracts>>,
  TError = ErrorType<unknown>,
>(
  params?: ContractsControllerGetMyContractsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerGetMyContracts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getContractsControllerGetMyContractsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 계약서 PDF 다운로드 URL 조회 (즉시 생성 지원)
 */
export const contractsControllerDownloadPdf = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<ContractsControllerDownloadPdf200>({
    url: `/contracts/${id}/download`,
    method: "GET",
    signal,
  });
};

export const getContractsControllerDownloadPdfQueryKey = (id?: string) => {
  return [`/contracts/${id}/download`] as const;
};

export const getContractsControllerDownloadPdfQueryOptions = <
  TData = Awaited<ReturnType<typeof contractsControllerDownloadPdf>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerDownloadPdf>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getContractsControllerDownloadPdfQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof contractsControllerDownloadPdf>>
  > = ({ signal }) => contractsControllerDownloadPdf(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof contractsControllerDownloadPdf>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ContractsControllerDownloadPdfQueryResult = NonNullable<
  Awaited<ReturnType<typeof contractsControllerDownloadPdf>>
>;
export type ContractsControllerDownloadPdfQueryError = ErrorType<unknown>;

export function useContractsControllerDownloadPdf<
  TData = Awaited<ReturnType<typeof contractsControllerDownloadPdf>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerDownloadPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerDownloadPdf>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerDownloadPdf>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useContractsControllerDownloadPdf<
  TData = Awaited<ReturnType<typeof contractsControllerDownloadPdf>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerDownloadPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerDownloadPdf>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerDownloadPdf>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useContractsControllerDownloadPdf<
  TData = Awaited<ReturnType<typeof contractsControllerDownloadPdf>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerDownloadPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 계약서 PDF 다운로드 URL 조회 (즉시 생성 지원)
 */

export function useContractsControllerDownloadPdf<
  TData = Awaited<ReturnType<typeof contractsControllerDownloadPdf>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerDownloadPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getContractsControllerDownloadPdfQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 계약서 PDF 스트리밍 (당사자 전용, 만료 없는 주소)
 */
export const contractsControllerStreamPdf = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<void>({ url: `/contracts/${id}/pdf`, method: "GET", signal });
};

export const getContractsControllerStreamPdfQueryKey = (id?: string) => {
  return [`/contracts/${id}/pdf`] as const;
};

export const getContractsControllerStreamPdfQueryOptions = <
  TData = Awaited<ReturnType<typeof contractsControllerStreamPdf>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerStreamPdf>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getContractsControllerStreamPdfQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof contractsControllerStreamPdf>>
  > = ({ signal }) => contractsControllerStreamPdf(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof contractsControllerStreamPdf>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ContractsControllerStreamPdfQueryResult = NonNullable<
  Awaited<ReturnType<typeof contractsControllerStreamPdf>>
>;
export type ContractsControllerStreamPdfQueryError = ErrorType<unknown>;

export function useContractsControllerStreamPdf<
  TData = Awaited<ReturnType<typeof contractsControllerStreamPdf>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerStreamPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerStreamPdf>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerStreamPdf>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useContractsControllerStreamPdf<
  TData = Awaited<ReturnType<typeof contractsControllerStreamPdf>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerStreamPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerStreamPdf>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerStreamPdf>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useContractsControllerStreamPdf<
  TData = Awaited<ReturnType<typeof contractsControllerStreamPdf>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerStreamPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 계약서 PDF 스트리밍 (당사자 전용, 만료 없는 주소)
 */

export function useContractsControllerStreamPdf<
  TData = Awaited<ReturnType<typeof contractsControllerStreamPdf>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerStreamPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getContractsControllerStreamPdfQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 계약 취소 확인서 PDF 다운로드 URL 조회 (즉시 생성 지원)
 */
export const contractsControllerDownloadCancellationPdf = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<ContractsControllerDownloadCancellationPdf200>({
    url: `/contracts/${id}/cancellation-download`,
    method: "GET",
    signal,
  });
};

export const getContractsControllerDownloadCancellationPdfQueryKey = (
  id?: string,
) => {
  return [`/contracts/${id}/cancellation-download`] as const;
};

export const getContractsControllerDownloadCancellationPdfQueryOptions = <
  TData = Awaited<
    ReturnType<typeof contractsControllerDownloadCancellationPdf>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerDownloadCancellationPdf>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getContractsControllerDownloadCancellationPdfQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof contractsControllerDownloadCancellationPdf>>
  > = ({ signal }) => contractsControllerDownloadCancellationPdf(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof contractsControllerDownloadCancellationPdf>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ContractsControllerDownloadCancellationPdfQueryResult = NonNullable<
  Awaited<ReturnType<typeof contractsControllerDownloadCancellationPdf>>
>;
export type ContractsControllerDownloadCancellationPdfQueryError =
  ErrorType<unknown>;

export function useContractsControllerDownloadCancellationPdf<
  TData = Awaited<
    ReturnType<typeof contractsControllerDownloadCancellationPdf>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerDownloadCancellationPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof contractsControllerDownloadCancellationPdf>
          >,
          TError,
          Awaited<ReturnType<typeof contractsControllerDownloadCancellationPdf>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useContractsControllerDownloadCancellationPdf<
  TData = Awaited<
    ReturnType<typeof contractsControllerDownloadCancellationPdf>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerDownloadCancellationPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof contractsControllerDownloadCancellationPdf>
          >,
          TError,
          Awaited<ReturnType<typeof contractsControllerDownloadCancellationPdf>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useContractsControllerDownloadCancellationPdf<
  TData = Awaited<
    ReturnType<typeof contractsControllerDownloadCancellationPdf>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerDownloadCancellationPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 계약 취소 확인서 PDF 다운로드 URL 조회 (즉시 생성 지원)
 */

export function useContractsControllerDownloadCancellationPdf<
  TData = Awaited<
    ReturnType<typeof contractsControllerDownloadCancellationPdf>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerDownloadCancellationPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getContractsControllerDownloadCancellationPdfQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 계약 생성 (PDF 자동 생성)
 */
export const contractsControllerCreateContract = (
  createContractRequestDto: BodyType<CreateContractRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ContractsControllerCreateContract201>({
    url: `/contracts`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createContractRequestDto,
    signal,
  });
};

export const getContractsControllerCreateContractMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof contractsControllerCreateContract>>,
    TError,
    { data: BodyType<CreateContractRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof contractsControllerCreateContract>>,
  TError,
  { data: BodyType<CreateContractRequestDto> },
  TContext
> => {
  const mutationKey = ["contractsControllerCreateContract"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof contractsControllerCreateContract>>,
    { data: BodyType<CreateContractRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return contractsControllerCreateContract(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ContractsControllerCreateContractMutationResult = NonNullable<
  Awaited<ReturnType<typeof contractsControllerCreateContract>>
>;
export type ContractsControllerCreateContractMutationBody =
  BodyType<CreateContractRequestDto>;
export type ContractsControllerCreateContractMutationError = ErrorType<unknown>;

/**
 * @summary 계약 생성 (PDF 자동 생성)
 */
export const useContractsControllerCreateContract = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof contractsControllerCreateContract>>,
      TError,
      { data: BodyType<CreateContractRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof contractsControllerCreateContract>>,
  TError,
  { data: BodyType<CreateContractRequestDto> },
  TContext
> => {
  const mutationOptions =
    getContractsControllerCreateContractMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * postpaid 로 체결된 계약이 실제 결제 완료된 시점에 프론트가 호출한다. paymentTransactionId 로 갱신하며, 이미 결제된 계약은 no-op(200).
 * @summary 후불결제 계약 결제 완료 처리 (buyer 전용)
 */
export const contractsControllerMarkContractPaid = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<void>({
    url: `/contracts/${id}/mark-paid`,
    method: "POST",
    signal,
  });
};

export const getContractsControllerMarkContractPaidMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof contractsControllerMarkContractPaid>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof contractsControllerMarkContractPaid>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["contractsControllerMarkContractPaid"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof contractsControllerMarkContractPaid>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return contractsControllerMarkContractPaid(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ContractsControllerMarkContractPaidMutationResult = NonNullable<
  Awaited<ReturnType<typeof contractsControllerMarkContractPaid>>
>;

export type ContractsControllerMarkContractPaidMutationError =
  ErrorType<unknown>;

/**
 * @summary 후불결제 계약 결제 완료 처리 (buyer 전용)
 */
export const useContractsControllerMarkContractPaid = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof contractsControllerMarkContractPaid>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof contractsControllerMarkContractPaid>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getContractsControllerMarkContractPaidMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 계약 — 씨마켓 카드결제 가능 여부(현재 상태)
 */
export const contractsControllerGetCardPaymentStatus = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<ContractsControllerGetCardPaymentStatus200>({
    url: `/contracts/${id}/card-payment-status`,
    method: "GET",
    signal,
  });
};

export const getContractsControllerGetCardPaymentStatusQueryKey = (
  id?: string,
) => {
  return [`/contracts/${id}/card-payment-status`] as const;
};

export const getContractsControllerGetCardPaymentStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof contractsControllerGetCardPaymentStatus>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerGetCardPaymentStatus>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getContractsControllerGetCardPaymentStatusQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof contractsControllerGetCardPaymentStatus>>
  > = ({ signal }) => contractsControllerGetCardPaymentStatus(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof contractsControllerGetCardPaymentStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ContractsControllerGetCardPaymentStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof contractsControllerGetCardPaymentStatus>>
>;
export type ContractsControllerGetCardPaymentStatusQueryError =
  ErrorType<unknown>;

export function useContractsControllerGetCardPaymentStatus<
  TData = Awaited<ReturnType<typeof contractsControllerGetCardPaymentStatus>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerGetCardPaymentStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerGetCardPaymentStatus>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerGetCardPaymentStatus>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useContractsControllerGetCardPaymentStatus<
  TData = Awaited<ReturnType<typeof contractsControllerGetCardPaymentStatus>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerGetCardPaymentStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerGetCardPaymentStatus>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerGetCardPaymentStatus>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useContractsControllerGetCardPaymentStatus<
  TData = Awaited<ReturnType<typeof contractsControllerGetCardPaymentStatus>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerGetCardPaymentStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 계약 — 씨마켓 카드결제 가능 여부(현재 상태)
 */

export function useContractsControllerGetCardPaymentStatus<
  TData = Awaited<ReturnType<typeof contractsControllerGetCardPaymentStatus>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerGetCardPaymentStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getContractsControllerGetCardPaymentStatusQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 특정 계약의 상세 정보를 조회합니다.
 * @summary 계약 조회 (PDF 상태 확인)
 */
export const contractsControllerGetContract = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<ContractsControllerGetContract200>({
    url: `/contracts/${id}`,
    method: "GET",
    signal,
  });
};

export const getContractsControllerGetContractQueryKey = (id?: string) => {
  return [`/contracts/${id}`] as const;
};

export const getContractsControllerGetContractQueryOptions = <
  TData = Awaited<ReturnType<typeof contractsControllerGetContract>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerGetContract>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getContractsControllerGetContractQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof contractsControllerGetContract>>
  > = ({ signal }) => contractsControllerGetContract(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof contractsControllerGetContract>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ContractsControllerGetContractQueryResult = NonNullable<
  Awaited<ReturnType<typeof contractsControllerGetContract>>
>;
export type ContractsControllerGetContractQueryError = ErrorType<unknown>;

export function useContractsControllerGetContract<
  TData = Awaited<ReturnType<typeof contractsControllerGetContract>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerGetContract>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerGetContract>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerGetContract>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useContractsControllerGetContract<
  TData = Awaited<ReturnType<typeof contractsControllerGetContract>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerGetContract>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerGetContract>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerGetContract>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useContractsControllerGetContract<
  TData = Awaited<ReturnType<typeof contractsControllerGetContract>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerGetContract>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 계약 조회 (PDF 상태 확인)
 */

export function useContractsControllerGetContract<
  TData = Awaited<ReturnType<typeof contractsControllerGetContract>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof contractsControllerGetContract>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getContractsControllerGetContractQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 계약 취소 (환불 처리)
 */
export const contractsControllerCancelContract = (
  id: string,
  cancelContractRequestDto: BodyType<CancelContractRequestDto>,
) => {
  return api<ContractsControllerCancelContract204>({
    url: `/contracts/${id}`,
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    data: cancelContractRequestDto,
  });
};

export const getContractsControllerCancelContractMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof contractsControllerCancelContract>>,
    TError,
    { id: string; data: BodyType<CancelContractRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof contractsControllerCancelContract>>,
  TError,
  { id: string; data: BodyType<CancelContractRequestDto> },
  TContext
> => {
  const mutationKey = ["contractsControllerCancelContract"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof contractsControllerCancelContract>>,
    { id: string; data: BodyType<CancelContractRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return contractsControllerCancelContract(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ContractsControllerCancelContractMutationResult = NonNullable<
  Awaited<ReturnType<typeof contractsControllerCancelContract>>
>;
export type ContractsControllerCancelContractMutationBody =
  BodyType<CancelContractRequestDto>;
export type ContractsControllerCancelContractMutationError = ErrorType<unknown>;

/**
 * @summary 계약 취소 (환불 처리)
 */
export const useContractsControllerCancelContract = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof contractsControllerCancelContract>>,
      TError,
      { id: string; data: BodyType<CancelContractRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof contractsControllerCancelContract>>,
  TError,
  { id: string; data: BodyType<CancelContractRequestDto> },
  TContext
> => {
  const mutationOptions =
    getContractsControllerCancelContractMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 계약을 최종 완료 처리하고 리뷰를 작성합니다.
 * @summary 계약 구매확정 (리뷰 작성 필수)
 */
export const contractsControllerCompleteContract = (
  id: string,
  completeContractRequestDto: BodyType<CompleteContractRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ContractsControllerCompleteContract200>({
    url: `/contracts/${id}/complete`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: completeContractRequestDto,
    signal,
  });
};

export const getContractsControllerCompleteContractMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof contractsControllerCompleteContract>>,
    TError,
    { id: string; data: BodyType<CompleteContractRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof contractsControllerCompleteContract>>,
  TError,
  { id: string; data: BodyType<CompleteContractRequestDto> },
  TContext
> => {
  const mutationKey = ["contractsControllerCompleteContract"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof contractsControllerCompleteContract>>,
    { id: string; data: BodyType<CompleteContractRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return contractsControllerCompleteContract(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ContractsControllerCompleteContractMutationResult = NonNullable<
  Awaited<ReturnType<typeof contractsControllerCompleteContract>>
>;
export type ContractsControllerCompleteContractMutationBody =
  BodyType<CompleteContractRequestDto>;
export type ContractsControllerCompleteContractMutationError =
  ErrorType<unknown>;

/**
 * @summary 계약 구매확정 (리뷰 작성 필수)
 */
export const useContractsControllerCompleteContract = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof contractsControllerCompleteContract>>,
      TError,
      { id: string; data: BodyType<CompleteContractRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof contractsControllerCompleteContract>>,
  TError,
  { id: string; data: BodyType<CompleteContractRequestDto> },
  TContext
> => {
  const mutationOptions =
    getContractsControllerCompleteContractMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 구매자가 계약 취소를 요청합니다.
 * @summary 계약 취소 요청 (구매자 → 판매자 승인 대기)
 */
export const contractsControllerRequestCancellation = (
  id: string,
  cancelContractRequestDto: BodyType<CancelContractRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ContractsControllerRequestCancellation200>({
    url: `/contracts/${id}/cancellation-request`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: cancelContractRequestDto,
    signal,
  });
};

export const getContractsControllerRequestCancellationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof contractsControllerRequestCancellation>>,
    TError,
    { id: string; data: BodyType<CancelContractRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof contractsControllerRequestCancellation>>,
  TError,
  { id: string; data: BodyType<CancelContractRequestDto> },
  TContext
> => {
  const mutationKey = ["contractsControllerRequestCancellation"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof contractsControllerRequestCancellation>>,
    { id: string; data: BodyType<CancelContractRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return contractsControllerRequestCancellation(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ContractsControllerRequestCancellationMutationResult = NonNullable<
  Awaited<ReturnType<typeof contractsControllerRequestCancellation>>
>;
export type ContractsControllerRequestCancellationMutationBody =
  BodyType<CancelContractRequestDto>;
export type ContractsControllerRequestCancellationMutationError =
  ErrorType<unknown>;

/**
 * @summary 계약 취소 요청 (구매자 → 판매자 승인 대기)
 */
export const useContractsControllerRequestCancellation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof contractsControllerRequestCancellation>>,
      TError,
      { id: string; data: BodyType<CancelContractRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof contractsControllerRequestCancellation>>,
  TError,
  { id: string; data: BodyType<CancelContractRequestDto> },
  TContext
> => {
  const mutationOptions =
    getContractsControllerRequestCancellationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 판매자가 채팅방에서 취소 요청을 승인합니다.
 * @summary 계약 취소 승인 (판매자)
 */
export const contractsControllerConfirmCancellation = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<ContractsControllerConfirmCancellation200>({
    url: `/contracts/${id}/cancellation-confirm`,
    method: "POST",
    signal,
  });
};

export const getContractsControllerConfirmCancellationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof contractsControllerConfirmCancellation>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof contractsControllerConfirmCancellation>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["contractsControllerConfirmCancellation"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof contractsControllerConfirmCancellation>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return contractsControllerConfirmCancellation(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ContractsControllerConfirmCancellationMutationResult = NonNullable<
  Awaited<ReturnType<typeof contractsControllerConfirmCancellation>>
>;

export type ContractsControllerConfirmCancellationMutationError =
  ErrorType<unknown>;

/**
 * @summary 계약 취소 승인 (판매자)
 */
export const useContractsControllerConfirmCancellation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof contractsControllerConfirmCancellation>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof contractsControllerConfirmCancellation>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getContractsControllerConfirmCancellationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 판매자가 구매자의 계약 취소 요청을 반려합니다.
 * @summary 계약 취소 반려 (판매자)
 */
export const contractsControllerRejectCancellation = (
  id: string,
  contractsControllerRejectCancellationBody: BodyType<ContractsControllerRejectCancellationBody>,
  signal?: AbortSignal,
) => {
  return api<ContractsControllerRejectCancellation200>({
    url: `/contracts/${id}/cancellation-reject`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: contractsControllerRejectCancellationBody,
    signal,
  });
};

export const getContractsControllerRejectCancellationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof contractsControllerRejectCancellation>>,
    TError,
    { id: string; data: BodyType<ContractsControllerRejectCancellationBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof contractsControllerRejectCancellation>>,
  TError,
  { id: string; data: BodyType<ContractsControllerRejectCancellationBody> },
  TContext
> => {
  const mutationKey = ["contractsControllerRejectCancellation"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof contractsControllerRejectCancellation>>,
    { id: string; data: BodyType<ContractsControllerRejectCancellationBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return contractsControllerRejectCancellation(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ContractsControllerRejectCancellationMutationResult = NonNullable<
  Awaited<ReturnType<typeof contractsControllerRejectCancellation>>
>;
export type ContractsControllerRejectCancellationMutationBody =
  BodyType<ContractsControllerRejectCancellationBody>;
export type ContractsControllerRejectCancellationMutationError =
  ErrorType<unknown>;

/**
 * @summary 계약 취소 반려 (판매자)
 */
export const useContractsControllerRejectCancellation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof contractsControllerRejectCancellation>>,
      TError,
      { id: string; data: BodyType<ContractsControllerRejectCancellationBody> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof contractsControllerRejectCancellation>>,
  TError,
  { id: string; data: BodyType<ContractsControllerRejectCancellationBody> },
  TContext
> => {
  const mutationOptions =
    getContractsControllerRejectCancellationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
